import actions from './multiple-session.actions'
import getters from './multiple-session.getters'
import state from './multiple-session.state'

export default {
  namespaced: true,
  actions,
  getters,
  state,
}
